import * as PopoverPrimitive from '@radix-ui/react-popover';

import PopoverContent from './components/PopoverContent';
import PopoverIcon from './components/PopoverIcon';

const Popover = ({ children, open, onOpenChange, defaultOpen, modal }: React.ComponentPropsWithRef<typeof PopoverPrimitive.Root>) => (
  <PopoverPrimitive.Root open={open} onOpenChange={onOpenChange} defaultOpen={defaultOpen} modal={modal}>
    {children}
  </PopoverPrimitive.Root>
);

Popover.Trigger = PopoverPrimitive.Trigger;
Popover.Content = PopoverContent;
Popover.Icon = PopoverIcon;

export { PopoverContent };

export default Popover;
